import { render } from "./breadcrumbadmin.vue?vue&type=template&id=f26ecaf8"
import script from "./breadcrumbadmin.vue?vue&type=script&lang=js"
export * from "./breadcrumbadmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__